<template>
  <form-group :validator="v" :attribute="attribute">
    <!-- <div class="form-group"> -->
      <label :for="label_for">{{ label_text }}</label>
      <input
        :type="input_type"
        class="form-control"
        v-model="input_v_model"
        :placeholder="placeholder"
        :maxlength="maxlength"
        @input="v.$touch()"
        :disabled="isDisabled"/>
    <!-- </div> -->
  </form-group>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    attribute: {
      type: String,
      default: ''
    },
    maxlength: {
      type: String,
      default: ''
    },
    label_for: {
      type: String,
      default: ''
    },
    label_text: {
      type: String,
      default: ''
    },
    input_type: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    v: {
      type: Object,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    input_v_model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/form/InputComponent.vue